module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.10.e9de4760.png";